import { Box, Container, Typography } from '@mui/material';
import { onSnapshot, query, where } from 'firebase/firestore';
import { concat, map, orderBy } from 'lodash';
import { ReactNode, useEffect, useState } from 'react';
import EventoCarteiraDb from '../../../db/eventoCarteiraDb';
import ExercicioDireitoDb from '../../../db/exercicioDireitoDb';
import OperacaoDb from '../../../db/operacaoDb';
import ExercicioDireito from '../../../models/exercicioDireito';
import {
  OperacaoLeitorBMF,
  OperacaoLeitorBovespa,
} from '../../../models/operacao';
import { useUsuario } from '../../../providers/usuarioProvider';
import TabelaEventos from '../../util/tabelas/tabelaEventos';
import TabelaExercicios from '../../util/tabelas/tabelaExercicios';
import { EventoCarteira } from '../../../models/eventoCarteira';
import { useLocation, useNavigate } from 'react-router-dom';
import TabelaOperacoesExtendida from '../../util/tabelas/tabelaOperacoesExtendida';
import CardPosicaoAtivo from '../analises/posicaoAtivo';
import Ativo from '../../../models/ativo';
import Functions from '../../../callable/functions';
import Ticker from '../../util/ui/ticker';
import { ClasseChip } from '../../util/ui/classeChip';
import ProcurarAtivo from '../../ativos/procurar';
import TabelaBase, {
  CelulaData,
  CelulaNumero,
  CelulaValor,
} from '../../util/tabelas/tabelaBase';
import usePosicaoAtivoPreenchida from '../analises/usePosicaoAtivoPreenchida';
import { felixTokens } from '../../../theme';

export default function Consulta() {
  const navigate = useNavigate();
  const { visualizado } = useUsuario();
  const location = useLocation();
  const [codigoAtivo, setCodigoAtivo] = useState(location.hash.slice(1));
  const [ativo, setAtivo] = useState<Ativo>();
  const [operacoesAtivo, setOperacoesAtivo] = useState<
    (OperacaoLeitorBMF | OperacaoLeitorBovespa)[]
  >([]);
  const [operacoesObjeto, setOperacoesObjeto] = useState<
    (OperacaoLeitorBMF | OperacaoLeitorBovespa)[]
  >([]);

  const [eventosAtivo, setEventosAtivo] = useState<EventoCarteira[]>([]);
  const [eventosObjeto, setEventosObjeto] = useState<EventoCarteira[]>([]);

  const [exerciciosAtivo, setExerciciosAtivo] = useState<ExercicioDireito[]>(
    [],
  );
  const [exerciciosObjeto, setExerciciosObjeto] = useState<ExercicioDireito[]>(
    [],
  );

  const { posicaoAtivoPreenchida, loading } =
    usePosicaoAtivoPreenchida(codigoAtivo);

  useEffect(() => {
    setCodigoAtivo(location.hash.slice(1));
  }, [location.hash]);

  useEffect(() => {
    navigate(`${location.pathname}#${codigoAtivo}`, { replace: true });
  }, [codigoAtivo]);

  useEffect(() => {
    if (!!visualizado && !!codigoAtivo)
      return onSnapshot(
        query(
          new OperacaoDb().collection({
            usuarioId: visualizado,
            operacaoId: '',
          }),
          where('codigoAtivo', '==', codigoAtivo),
        ),
        (query) => setOperacoesAtivo(map(query.docs, (doc) => doc.data())),
      );
  }, [visualizado, codigoAtivo]);

  useEffect(() => {
    if (!!visualizado && !!codigoAtivo)
      return onSnapshot(
        query(
          new OperacaoDb().collection({
            usuarioId: visualizado,
            operacaoId: '',
          }),
          where('codigoObjeto', '==', codigoAtivo),
        ),
        (query) => setOperacoesObjeto(map(query.docs, (doc) => doc.data())),
      );
  }, [visualizado, codigoAtivo]);

  useEffect(() => {
    if (!!visualizado && !!codigoAtivo)
      return onSnapshot(
        query(
          new EventoCarteiraDb().collection({
            usuarioId: visualizado,
            eventoId: '',
          }),
          where('codigoObjeto', '==', codigoAtivo),
        ),
        (query) => setEventosAtivo(map(query.docs, (doc) => doc.data())),
      );
  }, [visualizado, codigoAtivo]);

  useEffect(() => {
    if (!!visualizado && !!codigoAtivo)
      return onSnapshot(
        query(
          new EventoCarteiraDb().collection({
            usuarioId: visualizado,
            eventoId: '',
          }),
          where('codigoAtivo', '==', codigoAtivo),
        ),
        (query) => setEventosObjeto(map(query.docs, (doc) => doc.data())),
      );
  }, [visualizado, codigoAtivo]);

  useEffect(() => {
    if (!!visualizado && !!codigoAtivo)
      return onSnapshot(
        query(
          new ExercicioDireitoDb().collection({
            usuarioId: visualizado,
            exercicioDireitoId: '',
          }),
          where('codigoAtivo', '==', codigoAtivo),
        ),
        (query) => setExerciciosAtivo(map(query.docs, (doc) => doc.data())),
      );
  }, [visualizado, codigoAtivo]);

  useEffect(() => {
    if (!!visualizado && !!codigoAtivo)
      return onSnapshot(
        query(
          new ExercicioDireitoDb().collection({
            usuarioId: visualizado,
            exercicioDireitoId: '',
          }),
          where('codigoObjeto', '==', codigoAtivo),
        ),
        (query) => setExerciciosObjeto(map(query.docs, (doc) => doc.data())),
      );
  }, [visualizado, codigoAtivo]);

  useEffect(() => {
    if (!!codigoAtivo)
      new Functions()
        .ativoAutoComplete({
          codigoAtivo,
        })
        .then((res) => {
          setAtivo(res.data?.ativo);
        });
  }, [codigoAtivo]);

  return (
    <Container
      maxWidth="lg"
      sx={(theme) => ({
        padding: {
          md: theme.spacing(4, 8),
          xs: theme.spacing(2, 2),
        },
      })}
    >
      <Typography
        variant="eyebrow"
        color="text.secondary"
        sx={{ display: 'block', mb: 1 }}
      >
        Consulta de ativo
      </Typography>
      {!!ativo ? (
        <Box pb={1}>
          <Typography variant="h1" color="text.primary">
            {ativo?.razaoSocial}
          </Typography>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            flexWrap="wrap"
            gap={1}
            mt={0.5}
          >
            <Typography variant="h3" color="text.secondary">
              {ativo?.nome}
            </Typography>
            <Box display="flex">
              <Ticker codigoAtivo={ativo?.codigoAtivo} />
            </Box>
            <Box display="flex">
              <ClasseChip classeAtivo={ativo?.classeAtivo} />
            </Box>
          </Box>
          {/* Metadado do ativo: rótulo mono uppercase + valor mono tabular. */}
          <Box
            display="grid"
            gridTemplateColumns="auto 1fr"
            alignItems="baseline"
            columnGap={1.5}
            rowGap={0.5}
            mt={2}
          >
            <Typography variant="labelMono" color="text.secondary">
              CNPJ
            </Typography>
            <Typography variant="dataMono" color="text.primary">
              {ativo?.cnpj}
            </Typography>
            <Typography variant="labelMono" color="text.secondary">
              ISIN
            </Typography>
            <Typography variant="dataMono" color="text.primary">
              {ativo?.isin}
            </Typography>
            {ativo?.cnpjAdm && (
              <>
                <Typography variant="labelMono" color="text.secondary">
                  CNPJ (administradora)
                </Typography>
                <Typography variant="dataMono" color="text.primary">
                  {ativo?.cnpjAdm}
                </Typography>
              </>
            )}
            {ativo?.razaoSocialAdm && (
              <>
                <Typography variant="labelMono" color="text.secondary">
                  Razão Social (administradora)
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {ativo?.razaoSocialAdm}
                </Typography>
              </>
            )}
          </Box>
        </Box>
      ) : (
        <Typography variant="h1" color="text.primary" sx={dataMonoTitulo}>
          {codigoAtivo}
        </Typography>
      )}
      <Box pb={2}>
        <ProcurarAtivo
          codigoAtivo={codigoAtivo}
          onChange={(value) => {
            setAtivo(value);
            if (value) setCodigoAtivo(value.codigoAtivo);
          }}
        />
      </Box>

      <Box marginTop={2} />
      <CardPosicaoAtivo
        titulo={`Posição de ${codigoAtivo}`}
        posicoes={posicaoAtivoPreenchida}
        loading={loading}
      />
      <SecaoTitulo>Histórico de posições</SecaoTitulo>
      <TabelaBase
        loading={loading}
        header={[
          { titulo: 'Data', key: 'data', ordem: 1, align: 'left' },
          { titulo: 'Quantidade', key: 'quantidade', ordem: 2, align: 'right' },
          {
            titulo: 'Preço Médio',
            key: 'precoMedio',
            ordem: 3,
            align: 'right',
          },
        ]}
        rows={map(posicaoAtivoPreenchida, (p) => ({
          data: <CelulaData data={p.data} />,
          quantidade: <CelulaNumero numero={p.quantidade} />,
          precoMedio: <CelulaValor valor={p.precoMedio} />,
        }))}
      />
      <SecaoTitulo>Operações</SecaoTitulo>
      <TabelaOperacoesExtendida
        operacoes={orderBy(
          concat(operacoesAtivo, operacoesObjeto),
          'dataPregao',
        )}
        showDate
      />
      <SecaoTitulo>Exercícios de Subscrições</SecaoTitulo>
      <TabelaExercicios
        exercicios={orderBy(
          concat(exerciciosAtivo, exerciciosObjeto),
          'dataExercicio',
        )}
      />
      <SecaoTitulo>Eventos</SecaoTitulo>
      <TabelaEventos
        eventos={orderBy(concat(eventosAtivo, eventosObjeto), 'dataEvento')}
      />
    </Container>
  );
}

/** Código de ativo é dado: mono tabular mesmo em título. */
const dataMonoTitulo = {
  fontFamily: felixTokens.fontMono,
  fontVariantNumeric: 'tabular-nums' as const,
  letterSpacing: '-0.01em',
};

/**
 * Header de seção do sistema: título à esquerda e uma hairline atravessando
 * o resto da linha (DESIGN.md → Assinaturas da marca, #4).
 */
function SecaoTitulo({ children }: { children: ReactNode }) {
  return (
    <Box display="flex" alignItems="center" gap={2} mt={4} mb={1.5}>
      <Typography variant="h3" color="text.primary" whiteSpace="nowrap">
        {children}
      </Typography>
      <Box flex={1} borderBottom={1} borderColor="divider" />
    </Box>
  );
}
